// Mini grafico a barre delle letture negli ultimi giorni (solo lettura)
export function ViewsChart({ viewsByDay, total, days = 14 }) {
  const data = [];
  const today = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    const key = d.toISOString().slice(0, 10);
    data.push({ key, label: d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }), v: (viewsByDay && viewsByDay[key]) || 0 });
  }
  const max = Math.max(1, ...data.map((d) => d.v));
  const sumLast = (n) => {
    const cut = new Date(today); cut.setDate(today.getDate() - (n - 1));
    return Object.entries(viewsByDay || {}).reduce((s, [k, v]) => (k >= cut.toISOString().slice(0, 10) ? s + (v || 0) : s), 0);
  };
  const week = sumLast(7);
  const month = sumLast(30);
  const allTime = typeof total === "number" ? total : Object.values(viewsByDay || {}).reduce((s, v) => s + (v || 0), 0);

  const Stat = ({ label, value, testid }) => (
    <div className="flex-1 rounded-lg bg-white/5 border border-white/10 px-3 py-2 text-center" data-testid={testid}>
      <div className="font-display text-2xl text-gold">{value}</div>
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
    </div>
  );

  return (
    <div data-testid="views-chart" className="rounded-xl border border-white/10 bg-[#0F172A] p-4">
      <p className="text-xs uppercase tracking-widest text-gold mb-3">Andamento letture</p>
      <div className="flex gap-2 mb-4">
        <Stat label="7 giorni" value={week} testid="views-week" />
        <Stat label="30 giorni" value={month} testid="views-month" />
        <Stat label="Totale" value={allTime} testid="views-total" />
      </div>
      <div className="flex items-end gap-1 h-24">
        {data.map((d) => (
          <div key={d.key} className="flex-1 flex flex-col items-center gap-1 group" title={`${d.label}: ${d.v}`}>
            <div className="w-full rounded-t bg-gold/70 group-hover:bg-gold transition-colors" style={{ height: `${Math.max(4, (d.v / max) * 100)}%` }} />
          </div>
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-muted-foreground mt-2">
        <span>{data[0].label}</span>
        <span>{data[data.length - 1].label}</span>
      </div>
    </div>
  );
}
